import React from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import BaseModal from '../ui-components/BaseModal';
import { setSnackbar } from 'flow/actions/app-actions';
import useAppContext from 'flow/hooks/useAppContext';
import IconButton from 'flow/components/ui-components/IconButton';
import Icon from 'flow/components/ui-components/Icon';
import { useHistory } from 'react-router-dom';
import { routes } from 'flow/types/routes';
import { copyToClipboardIsSupported } from 'flow/utils/dom-utils';
import { generatePath } from 'flow/utils/router-utils';

interface Props {
    url?: string;
}

const DashboardCreatedDialog = ({ url }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();

    const onClickCopyUrl = () => {
        navigator.clipboard.writeText(url).then(() => {
            dispatch(
                setSnackbar({
                    message: i18next.t('snackbar.copied_to_clipboard'),
                }),
            );
        });
    };

    return (
        <BaseModal
            open={true}
            ariaLabel={i18next.t('wallboard.create.success')}
            confirmButtonText={i18next.t('ok')}
            hideCancelButton={true}
            onSubmit={() =>
                history.push(generatePath(routes['settings.dashboards']))
            }
            className="w-[500px]"
        >
            <div className="flex flex-col items-center justify-center gap-y-7">
                <Icon
                    iconKey="success"
                    size="3rem"
                    className="fill-green text-green"
                />
                <div className="flex flex-col items-center justify-center gap-y-4.5">
                    <div className="text-xl font-bold">
                        {i18next.t('wallboard.create.success')}
                    </div>
                    <div className="text-wrap">
                        {i18next.t('wallboard.create.url_description')}
                    </div>
                    <div className="flex w-full flex-row gap-x-3">
                        <a
                            className="text-link flex grow items-center justify-center overflow-hidden rounded-sm border border-gray-300 px-3 text-xs text-ellipsis whitespace-nowrap"
                            target="_blank"
                            rel={'noopener noreferrer'}
                            href={url}
                        >
                            {url}
                        </a>

                        {copyToClipboardIsSupported ? (
                            <IconButton
                                onClick={onClickCopyUrl}
                                tooltipLabel={i18next.t(
                                    'videoconference.join_info.copy_link',
                                )}
                            >
                                <Icon iconKey="copy" />
                            </IconButton>
                        ) : null}
                    </div>
                    <div className="flex-start flex flex-row items-center gap-x-2.5 rounded-sm bg-gray-200 p-3">
                        <Icon iconKey="errorFilled" className="size-4" />
                        <div className="text-xs font-medium">
                            {i18next.t('wallboard.create.url_information')}
                        </div>
                    </div>
                </div>
            </div>
        </BaseModal>
    );
};

export default DashboardCreatedDialog;
